/**
 * Imagem que abre grande num diálogo (BRAZ-21): clicar na miniatura do chat mostra a imagem por
 * cima da mesa, com "Abrir em outra aba" para quem quer o arquivo sozinho (o que o clique fazia
 * antes). O diálogo vai para o `body` do documento da miniatura, então abre na janela certa
 * também com o chat destacado (docs/spec/popout-windows.md).
 */
import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useT } from '../i18n/index.js';
import { Button, Dialog } from './controls.js';
import './imageViewer.css';

/** `fill`: a imagem ocupa o diálogo mesmo quando é menor (a foto de uma pessoa, que é pequena). */
export function ImageViewerDialog({ src, name, fill, onClose }: { src: string; name?: string; fill?: boolean; onClose: () => void }) {
  const t = useT();
  return (
    <Dialog
      title={name || t('imageViewer.title')}
      onClose={onClose}
      wide
      actions={
        <>
          <a className="rd-btn rd-btn--secondary rd-imageViewer__tab" href={src} target="_blank" rel="noreferrer noopener" onClick={onClose}>
            {t('imageViewer.openTab')}
          </a>
          <Button variant="action" onClick={onClose}>
            {t('common.close')}
          </Button>
        </>
      }
    >
      <div className={`rd-imageViewer${fill ? ' rd-imageViewer--fill' : ''}`}>
        <img src={src} alt={name ?? ''} />
      </div>
    </Dialog>
  );
}

/** A miniatura (um botão com a imagem dentro) e o diálogo que ela abre. */
export function ViewableImage({ src, name, className, imgClassName }: { src: string; name?: string; className?: string; imgClassName?: string }) {
  const t = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLButtonElement>(null);
  const label = name || t('imageViewer.title');
  return (
    <>
      <button ref={ref} type="button" className={`rd-imageThumb${className ? ` ${className}` : ''}`} title={label} aria-label={t('imageViewer.open', { name: label })} onClick={() => setOpen(true)}>
        <img className={imgClassName} src={src} alt={name ?? ''} loading="lazy" />
      </button>
      {open && ref.current ? createPortal(<ImageViewerDialog src={src} name={name} onClose={() => setOpen(false)} />, ref.current.ownerDocument.body) : null}
    </>
  );
}
